export const fetchStripeProductPackages = ({
  productId,
  type = 'good',
  currency = 'mxn'
}) => {
  const queryString = new URLSearchParams({
    type,
    currency
  });
  return {
    method: 'GET',
    url: `/integrations/stripe/products/${productId}/packages?${queryString.toString()}`
  };
};

export const createRoom = (data) => ({
  method: 'POST',
  url: '/twilio/room',
  data
});

export const createToken = (data) => ({
  method: 'POST',
  url: '/twilio/grant',
  data
});

export const createComposition = (data) => ({
  method: 'POST',
  url: '/twilio/composition',
  data
});